import { SafeDictionary } from "@insite/client-framework/Common/Types";
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import validatePhone from "@insite/client-framework/Common/Utilities/validatePhone";
import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, ValidatePostalCode } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import {
    AddressFieldDisplayCollectionModel,
    AddressFieldDisplayModel,
    BaseAddressModel,
    CustomerValidationDto,
} from "@insite/client-framework/Types/ApiModels";

export type AddressErrors = SafeDictionary<React.ReactNode>;

type HandlerType = Handler<
    {
        address: BaseAddressModel;
        validationRules: CustomerValidationDto;
        addressFieldDisplayCollection: AddressFieldDisplayCollectionModel;
    } & HasOnSuccess<AddressErrors>,
    {
        addressErrors: AddressErrors;
    }
>;

const isEmpty = (value: string) => value.trim().length <= 0;

const getRequiredErrorMessage = (addressFieldDisplayCollection: AddressFieldDisplayModel) =>
    siteMessage("Field_Required", addressFieldDisplayCollection.displayName);

export const CustomValidatePostalCode: HandlerType = props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { postalCode } = props.parameter.address;

    const isValidPostalCode =
    /^\d{5}$/.test(postalCode) ||              // exactly 5 digits
    /^\d{5}-\d{4}$/.test(postalCode) ||        // 5 digits + hyphen + 4 digits
    (/^\d{9}$/.test(postalCode) && postalCode.length === 9); // 9 digits (no hyphen)

    if (
        addressFieldDisplayCollection.postalCode?.isVisible &&
        validationRules.postalCode?.isRequired 
    ) {
        if(isEmpty(postalCode)){
            props.addressErrors.postalCode = getRequiredErrorMessage(addressFieldDisplayCollection.postalCode);
        } else if(!isValidPostalCode) {
            props.addressErrors.postalCode = siteMessage('postalCodeMinimum_errorMsg');
        }
    }
};

replaceInChain(chain, ValidatePostalCode, CustomValidatePostalCode);
 